import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/User';
import { PropertyMatrixSharedService } from '../property-matrix-shared.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  readonly api = 'https://localhost:44302/api/v1/';
  constructor(private http: HttpClient, private authService: PropertyMatrixSharedService) { }

  getById(id: string) {
    return this.http.get<User>(this.api + `User/profile/${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.authService.getToken()}`
      }
    });
  }
}